const noop = function () {};

const createNoopMixpanel = function () {
  return {
    init: noop,
    identify: noop,
    register: noop,
    register_once: noop,
    unregister: noop,
    reset: noop,
    track: noop,
    people: {
      set: noop,
      increment: noop,
      setPushId: noop,
      set_once: noop,
      unset: noop,
    },
    start_session_recording: noop,
    stop_session_recording: noop,
    get_session_replay_url: function () {
      return null;
    },
  };
};

const canUseMixpanelStorage = function () {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    const storage = window.localStorage;
    if (!storage) {
      return false;
    }
    const testKey = "__trebble_mixpanel_storage_test__";
    storage.setItem(testKey, testKey);
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

let mixpanel = createNoopMixpanel();

if (canUseMixpanelStorage()) {
  try {
    const loadedMixpanel = require("mixpanel-browser/dist/mixpanel.cjs.js");
    mixpanel =
      loadedMixpanel && loadedMixpanel.default
        ? loadedMixpanel.default
        : loadedMixpanel;
  } catch (error) {
    console.error("Failed loading Mixpanel. Falling back to no-op implementation. Error:" + error);
  }
}

export default mixpanel;
